import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useAdminStore, useKnowledgeStore } from '@getmayday/vue-modules';
import { computeNavigationLanguage } from '../utils/lang';

export default (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const { silent } = to.query;

  if (silent || !to.name || !to.matched.some((record) => record.meta.lang)) {
    return next();
  }

  const knowledgeStore = useKnowledgeStore();
  const { getKnowledgeByValue } = knowledgeStore;

  const adminStore = useAdminStore();
  const { contentLanguage } = storeToRefs(adminStore);

  const knowledge = getKnowledgeByValue(to.params.knowledgeId as string);
  const { lang } = to.params as { lang?: string };

  const focusLanguage =
    lang || computeNavigationLanguage(knowledge, contentLanguage.value);

  knowledgeStore.mutate({ focusLanguage });

  next();
};
